import type { IAnalyticsPropWithLocale } from '@inter-ikea-kompis/analytics'
import { DexfSettingsEnvironmentEnum, DexfSettingsFilterSegmentEnum } from '@inter-ikea-kompis/enums'

import { ICF_VERSION } from '@/constants/icf'
import { getLocaleFromPath } from '@/utils/base-path-params'

const locale = getLocaleFromPath()
export const DEXF_API_KEY = '36d0ffe2-38b4-4706-afb3-c9630e9d6efb'
export const APP_ID = 'sofaplatform'

// Dexf has ZZ as a test locale, but Kompis uses XZ
const TRANSLATION_ENDPOINTS = [
  '/addon-app/translations/kompis/en-XZ.json',
  `/addon-app/translations/kompis/${locale === 'en-ZZ' ? 'en-XZ' : '{language}-{country}'}.json`,
  `/addon-app/sofas/platform/translations/${locale === 'en-ZZ' ? 'en-XZ' : '{language}-{country}'}.json`,
]

export function getDexfFilterSegment() {
  const mode = import.meta.env.MODE

  if (mode === 'development') {
    return DexfSettingsFilterSegmentEnum.development
  }

  // CTE deployments
  if (mode === 'cte') {
    return DexfSettingsFilterSegmentEnum.verification
  }
  return DexfSettingsFilterSegmentEnum.production
}

export const KOMPIS_SERVICE_BASE_SETTINGS = {
  applicationName: APP_ID,
  consumer: 'FIRST',
  contract: '36341',
  dexfApiKey: DEXF_API_KEY,
  dexfApplicationId: APP_ID,
  dexfEnvironment: DexfSettingsEnvironmentEnum.production,
  filterSegment: getDexfFilterSegment(),
  locale,
  translationEndpoints: TRANSLATION_ENDPOINTS,
  dexfIcfVersion: ICF_VERSION,
}

export const KOMPIS_ANALYTICS_SETTINGS: IAnalyticsPropWithLocale = {
  ab: false, // Set to true to enable automatic A/B tests
  dev: import.meta.env.MODE !== 'production', // Set to true when testing to send events to QA environment
  disableCookieConsent: import.meta.env.DEV, // Disable cookie consent in dev mode
  locale: getLocaleFromPath(),
}
